import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { ReactComponent as CheckBoxIcon } from 'assets/images/icons/check_box_24(1).svg';

export const ClusterMunitionView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="3.5"
      titleUA="Касетні боєприпаси"
      titleEN="Cluster Munition"
      children={
        formData.info.hazard_type.cluster_munition && <CheckBoxIcon />
      }
    />
  );
};
